import * as React from "react";

import "./delivery-status.scss";

import {cs}                              from "@Common/react/chain-services";
import {consumeContext}                  from "@Common/react/context";
import {keyed}                           from "@Common/react/keyed";
import {Load2}                           from "@Common/react/load2";
import {formatDate3, formatDateTimeOnly} from "@Common/ui-components/format-date";
const fedexLogo = require("../../../../../../public/assets/fedex_logo_small.gif");
const dhlLogo = require("../../../../../../public/assets/dhl_logo.gif");

export const ShippedStatusContent = ({item}) => cs(
    consumeContext("apis"),
    ["trackingDetails", ({apis}, next) => {
        const trackingId = item.externalTrackingInfo?.tracking_id;
                return Load2({
            _key: trackingId,
            fetch: () => !trackingId ? apis.next.shipping.getShippingTrackingInfo(item.itemId) : apis.next.shipping.getShippingTrackingDetails(trackingId),
            next,
        });
    }],
    ({trackingDetails}) => (
        <div className="shipped-details-u3e">
            <div className="header">
                <div className="left">
                    <div className="item-name">
                        {item.itemName}
                    </div>
                    <div className="tracking-id">
                        {trackingDetails?.value?.shipment?.trackId ? "Tracking# " + trackingDetails?.value?.shipment?.trackId : ''}
                    </div>
                </div>
                <div className="right">
                    <div className="thumbnail-logo">
                        {trackingDetails?.value?.shipment?.provider && <img
                            src={(trackingDetails?.value?.shipment?.provider === 'DHL' ? dhlLogo : fedexLogo)}
                            alt={trackingDetails?.value?.shipment?.provider}
                        />}
                    </div>
                </div>
            </div>
            <div className="long-divider"></div>
            {trackingDetails ? <>
                <div className="middle">
                    <div className="header-line">
                        <div className="date-shipped">
                            DATE/TIME
                        </div>
                        <div className="activity">
                            ACTIVITY
                        </div>
                        <div className="shipped-location">
                            LOCATION
                        </div>
                    </div>
                    <div className="divider"/>
                    {trackingDetails.loading ? (
                        <div className="message" xd-qa-type="label" xd-qa-name="Loading">Shipping Details Loading...</div>
                    ) : !trackingDetails.value || !trackingDetails.value?.shipment || trackingDetails.value?.shipment.code ? (
                        <div className="message" xd-qa-type="label" xd-qa-name="Error">
                            Tracking info unavailable.  Please try again later.
                        </div>
                    ) : trackingDetails.value?.shipment?.events?.trackStatus ? (
                        <div className="message" xd-qa-type="label" xd-qa-name="Status">
                            {trackingDetails.value.shipment?.events.trackStatus}
                        </div>
                    ) : trackingDetails.value?.shipment?.events ? (
                        trackingDetails.value?.shipment?.events.map((tracking, i) => <>
                            {keyed(i)}
                            <div className="sub-divider"/>
                            {tracking && (
                                <div className="line-item">
                                    <div className="date-shipped">
                                        {hideDuplicateDate({
                                            value: formatDate3(new Date(trackingDetails.value.shipment?.events[i]?.trackEventTime)),
                                            nextValue: formatDate3(
                                                trackingDetails.value.shipment?.events?.[i + 1]?.trackEventTime &&
                                                new Date(trackingDetails.value.shipment.events[i + 1].trackEventTime)
                                            ),
                                        })}
                                    </div>
                                    <div className="time-shipped">{formatDateTimeOnly(new Date(tracking?.trackEventTime))}</div>
                                    <div className="activity-content">{tracking?.trackStatus}</div>
                                    <div className="shipped-location">{tracking?.trackLocation}</div>
                                </div>
                            )}
                        </>)
                    ) : (
                        <div className="middle">Tracking info unavailable. Please try again later.</div>
                    )}
                </div>
                <div className="bottom">
                    <div className="long-divider"></div>
                </div>
            </> : (
                <div className="middle">Tracking info unavailable. Please try again later.</div>
            )}

        </div>
    ),
);

const hideDuplicateDate = ({value, nextValue}) => ((nextValue !== value) ? value : null);
